export const AID_USER_ID = 'aidUserId'


export const COIN_TICKER_AND_FULL_NAME_LIST = [
    {
        network: '1',
        ticker: 'eth',
        fullName: 'Ethereum'
    },
    {
        network: '56',
        ticker: 'bsc',
        fullName: 'Binance Smart Chain'
    },
    {
        network: '137',
        ticker: 'matic',
        fullName: 'Polygon'
    },
    {
        network: 'sol',
        ticker: 'sol',
        fullName: 'Solana'
    },
    {
        network: '8217',
        ticker: 'klay',
        fullName: 'klaytn'
    },
]


// const smallLogoCSS: CSSProperties = {width: '30px', height: '30px'}
//
// export const CHAIN_NETWORK_LIST = [
//     {
//         chainId: '0x38',
//         name: 'Binance Smart Chain',
//         logo: <MemoCoinImage bgColor={'bsc-bg-color'} logoSrc={binance} coinName={'binance'} style={smallLogoCSS}/>
//     },
//     {
//         chainId: '0x00',
//         name: 'Ethereum',
//         logo: <MemoCoinImage bgColor={'eth-bg-color'} logoSrc={eth} coinName={'Ethereum'} style={smallLogoCSS}/>
//     },
//     {
//         chainId: '0x89',
//         name: 'Polygon',
//         logo: <MemoCoinImage bgColor={'matic-bg-color'} logoSrc={polygon} coinName={'Polygon'} style={smallLogoCSS}/>
//     },
//     {
//         chainId: '0x2019',
//         name: "Klaytn",
//         logo: <MemoCoinImage bgColor={'klay-bg-color'} logoSrc={klaytn} coinName={'klaytn'} style={smallLogoCSS}/>
//     },
//     {
//         chainId: 'sol',
//         name: "Solana",
//         logo: <MemoCoinImage bgColor={'sol-bg-color'} logoSrc={solana} coinName={'solana'} style={smallLogoCSS}/>
//     }
// ]